import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../../AxiosClient";

export const getAllTestAsync = createAsyncThunk(
  "admin/getAllTest",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllTest?page=${payload.page}&limit=${payload.limit}&category=${
        payload.category || ""
      }&classes=${payload.classes || ""}&title=${payload.title || ""}`,
      [],
      toolkit
    );
  }
);

export const createTestAsync = createAsyncThunk(
  "admin/createTest",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/createTest`, payload, toolkit);
  }
);

export const updateTestByIdAsync = createAsyncThunk(
  "admin/updateTestById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PATCH",
      `/updateTestById/${payload?.Id}`,
      payload,
      toolkit
    );
  }
);

export const deleteTestByIdAsync = createAsyncThunk(
  "admin/deleteTestById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteTestById/${payload}`,
      [],
      toolkit
    );
  }
);

//TestReport

export const getallTestReportsAsync = createAsyncThunk(
  "admin/getAllTestReports",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllTestReports?page=${payload.page}&limit=${
        payload.limit
      }&studentId=${payload.studentId || ""}`,

      [],
      toolkit
    );
  }
);

export const getTestAttemptedCountAsync = createAsyncThunk(
  "admin/getAttemptCount",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAttemptCount?testId=${payload.testId}&userId=${payload.userId}`,
      [],
      toolkit
    );
  }
);

export const getTestReportByCountAsync = createAsyncThunk(
  "admin/getOwnTestReportById",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/getOwnTestReportById`, payload, toolkit);
  }
);

export const getTestReportByIdAsync = createAsyncThunk(
  "admin/getTestReportById",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/getTestReportById`, payload, toolkit);
  }
);

export const getTestByIdAsync = createAsyncThunk(
  "admin/getTestById",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getTestById/${payload}`, [], toolkit);
  }
);

export const testQuestionViewerAsync = createAsyncThunk(
  "admin/testQuestionViewer",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/testQuestionViewer/${payload}`,
      [],
      toolkit
    );
  }
);

export const getPracticeTestByIdAsync = createAsyncThunk(
  "admin/getPracticeTestById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getPracticeTestById/${payload}`,
      [],
      toolkit
    );
  }
);

// Test Report By Graph
export const getStudentTestReportGraphAsync = createAsyncThunk(
  "admin/getTestById",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getStudentTestReport/${payload}`,
      [],
      toolkit
    );
  }
);

//Master Test

export const masterTestByGoalIdAsync = createAsyncThunk(
  "admin/masterTestByGoalId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/masterTestByGoalId?goalId=${payload?.goalId}`,
      payload,
      toolkit
    );
  }
);

export const addMasterTestAsync = createAsyncThunk(
  "admin/addMasterTest",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addMasterTest`, payload, toolkit);
  }
);

export const getAllMasterTestAsync = createAsyncThunk(
  "admin/getAllMasterTest",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllMasterTest?page=${payload.page}&limit=${payload.limit}&search=${
        payload.search || ""
      }`,
      [],
      toolkit
    );
  }
);

export const getMasterTestAsync = createAsyncThunk(
  "admin/getMasterTest",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getMasterTest/${payload}`,
      payload,
      toolkit
    );
  }
);

export const updateMasterTestByIdAsync = createAsyncThunk(
  "admin/updateMasterTestById",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateMasterTestById`, payload, toolkit);
  }
);
